export default __webpack_public_path__ + "static/media/mainpic2.d198612d.png";